<template>
  <v-dialog
    scrollable
    v-model="visible"
    max-width="900px"
    :fullscreen="fullscreen"
    :persistent="true"
  >
    <v-card>
      <v-toolbar flat dense>
        <v-toolbar-title class="subheading">{{ title }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="fullscreen=!fullscreen">
          <v-icon>fullscreen</v-icon>
        </v-btn>
      </v-toolbar>

      <v-divider style="max-height: 1px"/>
      <v-progress-linear class="my-0" :indeterminate="true" :active="loading" height="2"/>

      <v-card-text>
        <v-form v-model="formValid" ref="formRef" lazy-validation>
          <v-container grid-list-md>
            <v-layout wrap>

              <v-flex xs6>
                <v-text-field
                  label="栏目名称"
                  required
                  :rules="rules.required"
                  v-model="item.name"/>
              </v-flex>

              <v-flex xs3>
                <v-text-field
                  label="标识符"
                  required
                  :rules="rules.identifier"
                  v-model="item.identifier"/>
              </v-flex>

              <v-flex xs3>
                <v-text-field
                  label="图标"
                  v-model="item.icon"
                  hint="www.material.io 图标名"
                  persistent-hint
                />
              </v-flex>

              <v-flex xs3>
                <v-autocomplete
                  label="显示于导航栏"
                  required
                  :rules="[ v => (v === true || v === false) || '必填项.']"
                  v-model="item.navigator"
                  :items="[{value: true, text:'是'}, {value: false, text:'否'}]"
                />
              </v-flex>

              <v-flex xs3>
                <v-autocomplete
                  label="上传封面图片"
                  required
                  :rules="[ v => (v === true || v === false) || '必填项.']"
                  v-model="item.coverPhoto"
                  :items="[{value: true, text:'是'}, {value: false, text:'否'}]"
                />
              </v-flex>

              <v-flex xs3>
                <v-text-field
                  label="排序"
                  required
                  :rules="rules.rank"
                  v-model="item.rank"
                  hint="数值小的显示顺序靠前."
                  persistent-hint
                />
              </v-flex>

              <v-flex xs3>
                <v-autocomplete
                  label="禁用"
                  required
                  :rules="[ v => (v === true || v === false) || '必填项.']"
                  v-model="item.disabled"
                  :items="[{value: true, text:'是'}, {value: false, text:'否'}]"
                />
              </v-flex>

              <v-flex xs12>
                <v-text-field
                  label="备注"
                  v-model="item.note"
                  :rules="rules.note"
                ></v-text-field>
              </v-flex>

            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer/>
        <v-btn color="blue darken-1" flat @click.native="visible = false">取消</v-btn>
        <v-btn color="primary" @click.native="onSave">保存
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
  import mixin from '@/mixin'

  const baseUri = '/api/web/section';

  export default {
    mixins: [mixin.edit(baseUri)],
    data() {
      return {
        formValid: false,

        item: {},
        freshItem: {
          "name": null,
          "rank": null,
          "disabled": null,
          "note": null
        },

        /**
         * 验证规则
         */
        rules: {
          required: [
            v => !!v || '必填项。'
          ],

          identifier:[
            v => !!v || '必填项。',
            v => (v && /^\w+$/ig.test(v)) || '只能填写一个单词。'
          ],

          rank:[
            v => !!v || '必填项。',
            v => (v && /^\d+$/ig.test(v)) || '只能填写正整数。'
          ],
          note: [v => (!v || v.length <= 50) || '长度必须小于50个字符。']
        }
      }
    }
  }
</script>
